import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';

import { SweetConfirmationAlert } from '../../components/Alert/sweetAlert';

//Material Components
import AppBar from "@material-ui/core/AppBar";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox';

//Engage Components
import {
    renderSelect,
    renderSwitchWithLabel,
} from '../../utils/engageComponents';

//Action
import { GetResidetTags, GetResidentsByTags, GetResidentsAllCommunities } from '../../actions/residentActions';
import { GetCommunityTags, getAllCommunitiesSTBVerison, GetCommunitiesByTags } from '../../actions/communityActions';
import { PostVersion, PutVersion, GetAllVersions } from '../../actions/versionActions';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';

//Alert
import { sweetAlert } from '../../components/Alert/sweetAlert'


const validate = (values) => {
    const errors = {};
    return errors;
};



export class AddVersion extends Component {
    constructor(props) {
        super(props)

        const versionSelected = this.props.versionSelected ? this.props.versionSelected : undefined;

        this.state = {
            //default
            flavors: [
                { name: 'staging' },
                { name: 'production' }
            ],
            //Version Information
            flavorSelected: (versionSelected?.version?.flavor) ? { name: versionSelected.version.flavor } : { name: 'staging' },
            downloadUrl: undefined,
            versionSelected: undefined,
            firstValueVersion: (versionSelected && !isNaN(versionSelected.major)) ? versionSelected.major + '' : undefined,
            secondValueVersion: (versionSelected && !isNaN(versionSelected.minor)) ? versionSelected.minor + '' : undefined,
            thirdValueVersion: (versionSelected && !isNaN(versionSelected.build)) ? versionSelected.build + '' : undefined,
            fourthValueVersion: (versionSelected && !isNaN(versionSelected.revision)) ? versionSelected.revision + '' : undefined,
            //error
            errorGenericText: 'Required Field',
            onErrorVersion: false,
            //Grouping Information
            groupByCommunity: (versionSelected?.byCommunity) ? versionSelected.byCommunity : false,
            criteriaSelected: (versionSelected?.byCommunity && versionSelected?.communities) ? { id: 2, name: 'by Community' } : (!versionSelected?.byCommunity && versionSelected?.residents) ? { id: 2, name: 'by resident' } : undefined,
            //Tags
            arrayCheckedTagsCommunity: [],
            arrayCheckedTagsResident: [],
            //ResidentsSelected
            residentsSelected: undefined, // (versionSelected?.residents)? versionSelected.residents :
            communitiesSelected: undefined,//(versionSelected?.communities)? versionSelected.communities :
            //toggle Select All
            selectAllTags: false,
            selectAllCommunities: undefined,
            selectAllResidents: undefined,
            //communityData
            communityData: [],
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
            //
            openVersionFlavorCombo: false,
            openGroupCriteriaCombo: false,
            versionUrl: "https://engage360.s3.amazonaws.com/app/engage360-.apk",
            //styles
            fixedHeight: '23rem',
            fixedBackgroundColor: '#1f1f1f',
            fixedBorderRadius: '12px',
            //Description
            versionDescription: (this.props.versionSelected && this.props.versionSelected.description) ? this.props.versionSelected.description : '',
            //Aproved
            versionAproved: (this.props.versionSelected && this.props.versionSelected.aproved) ? this.props.versionSelected.aproved : false,
        }

        //Version Information
        this.props.dispatch(change('AddVersionForm', 'AddVersionFlavor', ''));

    };

    //Criteria Aviable
    SELECT_CRITERIA = 'Select a criteria';
    BY_COMMUNITY_TAG = 'by community tag';
    BY_COMMUNITY = 'by Community';
    BY_RESIDENT_TAG = 'by resident tag';
    BY_RESIDENT = 'by resident';
    BY_RESIDENT_BY_COMMUNITY = 'by resident by community'

    componentDidMount() {

        this.loadInfo();

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        this.SetHeaderButtons();

    };

    loadInfo = async () => {
        try {
            this.props.GetResidetTags();
            this.props.GetCommunityTags();

            //Clean ResidentsReducer 
            this.props.GetResidentsByTags('');

            //Get Communities
            this.props.getAllCommunitiesSTBVerison();

            if (this.props.versionSelected) {

                this.props.GetResidentsAllCommunities();
            }

        } catch (err) { }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
        this.props.SetHeaderButtons(undefined);
    }

    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();
        this.props.SetHeaderButtons(headerButtons)
    }

    getHeaderButtons = () => {
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return (
            <div style={styles.globalActions}>
                <div
                    id='Version_save_btn'
                    className="blueBottomButon appbtnBarButton"
                    onClick={this.ConfirmationHandler}
                    style={styles.globalActions}>
                    {this.props.versionSelected ? 'Update' : 'Save'}
                </div>
            </div>
        )
    }


    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region Text Field

    checkValidInput = (input, field) => {
        let pattern = '^\\d{1,3}$';

        if (input && input.length > 0 && field && field.length > 0) {
            if (input.length > 0) {
                var regex = new RegExp(pattern);

                if (!regex.test(input)) {
                    input = input.substring(0, input.length - 1);
                }
            }
        }
        this.setState({ [field]: input });
    }

    AddTagToCheckedArray = (tag, criteriaSelected) => {

        let indexOfTag = -1;
        let array = (criteriaSelected === 'by community tag') ? [...this.state.arrayCheckedTagsCommunity] : [...this.state.arrayCheckedTagsResident];


        let allTagsAreSelected = false;

        switch (criteriaSelected) {
            case 'by community tag':
                indexOfTag = this.state.arrayCheckedTagsCommunity.indexOf(tag);
                if (indexOfTag === -1) {
                    array.push(tag);
                } else {
                    array.splice(indexOfTag, 1);
                }

                this.props.GetCommunitiesByTags(array.join(','))


                if (this.checkIfAllTagsAreSelected(criteriaSelected)) {
                    allTagsAreSelected = true;
                }

                this.setState({
                    arrayCheckedTagsCommunity: array,
                    selectAllTags: allTagsAreSelected
                });
                break
            case 'by resident tag':
                indexOfTag = this.state.arrayCheckedTagsResident.indexOf(tag);
                if (indexOfTag === -1) {
                    array.push(tag);
                } else {
                    array.splice(indexOfTag, 1);
                }

                this.props.GetResidentsByTags(array.join(','));



                if (this.checkIfAllTagsAreSelected(criteriaSelected, array)) {
                    allTagsAreSelected = true;
                }

                this.setState({
                    arrayCheckedTagsResident: array,
                    selectAllTags: allTagsAreSelected
                });
                break;
            default:
                break;
        }
    }

    checkIfAllTagsAreSelected = (criteriaSelected, array) => {
        let result = true;
        let allTagsInProps = [];
        let allTagsSelected = array ? array : [];

        switch (criteriaSelected) {
            case 'by community tag':
                allTagsInProps = this.props.communityTags ? this.props.communityTags : [];
                break;
            case 'by resident tag':
                allTagsInProps = this.props.residentTags ? this.props.residentTags : [];
                break;
            default:
                break;
        }



        for (let props = 0; props < allTagsInProps.length; props++) {
            const indexOfPropsInSelected = allTagsSelected.indexOf(allTagsInProps[props]);

            if (indexOfPropsInSelected === -1) {
                result = false;
                break;
            }
        }

        return result;
    };


    SetCriteriaSelected = (criteriaSelected) => {

        //Clean ResidentsReducer 
        this.props.GetResidentsByTags('');

        if (criteriaSelected) {


            switch (criteriaSelected.name) {
                case 'by resident tag':
                    this.props.GetResidentsByTags(this.state.arrayCheckedTagsResident ? this.state.arrayCheckedTagsResident.join(',') : '');
                    break;
                case 'by resident':
                    this.props.GetResidentsAllCommunities();
                    break;
                case 'by resident by community':
                    //Get Communities
                    this.props.getAllCommunitiesSTBVerison();
                    //Get residents
                    this.props.GetResidentsAllCommunities();
                    break;
                case 'by community tag':
                    //Get Communities
                    this.props.GetCommunitiesByTags(this.state.arrayCheckedTagsCommunity ? this.state.arrayCheckedTagsCommunity.join(',') : '');
                    break;
                case 'by Community':
                    //Get Communities
                    this.props.getAllCommunitiesSTBVerison();
                    break;
                default:
                    break;
            }
        }

        this.setState({
            criteriaSelected: criteriaSelected,
            residentsSelected: [],
            communitiesSelected: [],
            arrayCheckedTagsCommunity: [],
            arrayCheckedTagsResident: [],
            selectAllCommunities: false,
            selectAllResidents: false,
            selectAllTags: false,
        });
        this.props.dispatch(change('AddVersionForm', 'GroupingCriteria', criteriaSelected));
    };

    AddResidentToSelectedArray = (residentInput) => {

        let AllResidentsAreSelected = false;
        let newResidentsSelectedArray = this.state.residentsSelected ? this.state.residentsSelected : [];
        const residentObjectInArray = newResidentsSelectedArray.find(resident => resident._id === residentInput._id);

        //new Resident
        if (!residentObjectInArray) {
            newResidentsSelectedArray.push(residentInput);
        } else {
            newResidentsSelectedArray = newResidentsSelectedArray.filter(resident => resident._id !== residentInput._id);
        }

        AllResidentsAreSelected = this.checkIfAllResidentsAreSelected(newResidentsSelectedArray);

        this.setState({ residentsSelected: newResidentsSelectedArray, selectAllResidents: AllResidentsAreSelected });
    };

    checkIfAllResidentsAreSelected = (newResidentsSelectedArray) => {
        let result = true;
        const residentsInProps = this.props.residentsData ? this.props.residentsData : [];
        const residentsSelected = newResidentsSelectedArray ? newResidentsSelectedArray : [];

        for (let resi = 0; resi < residentsInProps.length; resi++) {
            const residentObjectSelected = residentsSelected.find(res => res._id === residentsInProps[resi]._id);

            if (!residentObjectSelected) {
                result = false;
                break;
            }
        }

        return result;


    };

    GetResidentBadge = (residentName) => {
        const arrayNames = residentName.split(' ');
        let badge = '';

        arrayNames.forEach(element => {
            if (element.length > 0) {
                badge = badge + element[0];
            }
        });

        if (badge.length > 2) {
            badge = badge.slice(0, 2)
        }
        badge = badge.toUpperCase();

        return badge;

    };

    toggleCommunitySelected = (community) => {

        let allCommunitiesSelected = true;
        const arrayCommunitiesSelected = this.state.communitiesSelected ? this.state.communitiesSelected : [];
        const communityObjectInArray = arrayCommunitiesSelected.find(comm => comm._id === community._id);

        let newCommunitiesSelectedArray = [...arrayCommunitiesSelected];

        if (!communityObjectInArray) {
            newCommunitiesSelectedArray.push(community);
        } else {
            newCommunitiesSelectedArray = newCommunitiesSelectedArray.filter(comm => comm._id !== community._id);
        }

        allCommunitiesSelected = this.checkIfAllAommunitiesAreSelected(newCommunitiesSelectedArray)

        this.setState({ communitiesSelected: newCommunitiesSelectedArray, selectAllCommunities: allCommunitiesSelected });
    };

    checkIfAllAommunitiesAreSelected = (newCommunitiesSelectedArray) => {
        let result = true;
        const allCommunitiesInProps = this.props.communityData;
        const allCommunitiesSelected = newCommunitiesSelectedArray ? newCommunitiesSelectedArray : [];

        for (let comm = 0; comm < allCommunitiesInProps.length; comm++) {
            const communityObjectFound = allCommunitiesSelected.find(commSelected => commSelected._id === allCommunitiesInProps[comm]._id);

            if (!communityObjectFound) {
                result = false;
                break;
            }
        }

        return result;


    };

    SelectAllCommunities = () => {
        const newSelectAllCommunities = !this.state.selectAllCommunities;

        const newCommunitiesArray = [];


        if (newSelectAllCommunities === true) {
            if (this.props.communityData && this.props.communityData.length > 0) {

                this.props.communityData.forEach(comm => newCommunitiesArray.push(comm))
            }

        }

        this.setState({
            selectAllCommunities: newSelectAllCommunities,
            communitiesSelected: newCommunitiesArray,
            residentsSelected: [],
        })

    }

    SelectAllResidents = (residents) => {
        const newSelectAllResidents = !this.state.selectAllResidents;

        const newResidentsArray = [];


        if (newSelectAllResidents === true) {
            if (residents && residents.length > 0) {

                residents.forEach(res => newResidentsArray.push(res))
            }

        }

        this.setState({
            selectAllResidents: newSelectAllResidents,
            residentsSelected: newResidentsArray,
        })

    };

    SelectAllTags = () => {

        const criteriaSelected = (this.state.criteriaSelected && this.state.criteriaSelected.name) ? this.state.criteriaSelected.name : '';
        const newSelectAllTags = !this.state.selectAllTags;

        let newTagsArray = [];
        let allTagsFromApi = [];

        if (criteriaSelected === 'by resident tag' || criteriaSelected === 'by community tag') {


            if (criteriaSelected === 'by community tag') {
                allTagsFromApi = (this.props.communityTags) ? this.props.communityTags : [];

                if (newSelectAllTags) {
                    newTagsArray = allTagsFromApi;
                }

                this.props.GetCommunitiesByTags(newTagsArray.join(','));

                this.setState({
                    arrayCheckedTagsCommunity: newTagsArray,
                    selectAllTags: newSelectAllTags,
                    residentsSelected: [],
                    communitiesSelected: [],
                });

            } else {
                allTagsFromApi = (this.props.residentTags) ? this.props.residentTags : [];

                if (newSelectAllTags) {
                    newTagsArray = allTagsFromApi;
                }

                this.props.GetResidentsByTags(newTagsArray.join(','));

                this.setState({
                    arrayCheckedTagsResident: newTagsArray,
                    selectAllTags: newSelectAllTags,
                    residentsSelected: [],
                    communitiesSelected: [],
                });
            }


        }

    };

    ConfirmationHandler = async () => {

        let errors = { message: '' };

        if (!this.checkForInfo(errors)) {
            let message = (errors && errors.message.length > 0) ? errors.message : ' validation error';

            message = message.split(',');
            if (Array.isArray(message) && message.length > 0 && message[0].length > 0) {
                message = message[0].charAt(0).toUpperCase() + message[0].slice(1);
            }

            sweetAlert('error', message, 'alert_Version_Error')
        } else {
            const title = 'Do you want to update the EHub right now?';
            const { isConfirmed, isDenied } = await SweetConfirmationAlert(title, 'alert_UpdateEHubNow');

            if (isConfirmed) {

                if (!this.props.versionSelected) {
                    this.SaveHandler(isConfirmed)
                } else {
                    this.EditHandler(isConfirmed)
                }
            }

            if (isDenied) {
                if (!this.props.versionSelected) {
                    this.SaveHandler(!isDenied)
                } else {
                    this.EditHandler(!isDenied)
                }
            }
        }

    }

    SaveHandler = (sendMessage = false) => {

        const objToSend = this.GetVersionToSend(sendMessage);

        if (!objToSend)
            return undefined;


        //Sending Object to Action
        this.props.PostVersion(objToSend);
        this.props.closeAddEditPage();
        this.props.GetAllVersions();


    };


    EditHandler = (sendMessage = false) => {
        try {
            const objToSend = this.GetVersionToSend(sendMessage);

            if (!objToSend)
                return undefined;

            if (this.props.versionSelected && this.props.versionSelected._id) {

                this.props.PutVersion(this.props.versionSelected._id, objToSend);
                this.props.closeAddEditPage();
                this.props.GetAllVersions();
            }

            return

        } catch (err) {
            return undefined;
        }
    };

    GetVersionToSend = (sendMessage = false) => {
        try {

            const objToSend = {};

            const flavorSelected = (this.state.flavorSelected && this.state.flavorSelected.name) ? this.state.flavorSelected.name : '';
            const finalVersion =
                this.state.firstValueVersion + '.' +
                this.state.secondValueVersion + '.' +
                this.state.thirdValueVersion + '.' +
                this.state.fourthValueVersion;

            const grounByCommunity = this.state.groupByCommunity ? this.state.groupByCommunity : false;
            const versionObject = {};

            versionObject.flavor = flavorSelected;
            versionObject.latestVersion = finalVersion;
            versionObject.downloadUrl = this.state.versionUrl;


            objToSend.version = versionObject;
            objToSend.byCommunity = grounByCommunity;
            objToSend.sendMessage = sendMessage;
            objToSend.aproved = this.state.versionAproved;
            objToSend.description = this.state.versionDescription;

            if (!grounByCommunity) {
                let residents = [];
                let residentTopics = [];

                if (this.props.residentsData && (this.state.residentsSelected && this.state.residentsSelected.length > 0)) {
                    residents = this.state.residentsSelected.filter(
                        resident => {
                            const residentInProps = this.props.residentsData.find(res => res._id === resident._id)

                            if (residentInProps) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    ).map(res => res._id);
                }

                residentTopics = this.state.residentsSelected.filter(
                    resident => {
                        const residentInProps = this.props.residentsData.find(res => res._id === resident._id)

                        if (residentInProps) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                ).map(res => `${res.communityUID}/${res._id}`);

                objToSend.communities = [];
                objToSend.residents = residents;
                objToSend.residentTopics = residentTopics;
            } else {
                let communities = [];

                if (this.props.communityData && (this.state.communitiesSelected && this.state.communitiesSelected.length > 0)) {
                    communities = this.state.communitiesSelected.filter(
                        community => {
                            const communityInProps = this.props.communityData.find(comm => comm._id === community._id)

                            if (communityInProps) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                    ).map(community => {
                        return community.communityId
                    });
                }

                objToSend.residents = [];
                objToSend.communities = communities;
            }

            return objToSend
        } catch (err) {
            return undefined;
        }
    }

    checkForInfo = (errors) => {

        let isOK = true;

        // version
        if (!(this.state.flavorSelected && (this.state.flavorSelected.name === 'staging' || this.state.flavorSelected.name === 'production'))) {
            isOK = false;
        }

        //versionParts
        if (!(
            (this.state.firstValueVersion && this.state.firstValueVersion.length > 0) &&
            (this.state.secondValueVersion && this.state.secondValueVersion.length > 0) &&
            (this.state.thirdValueVersion && this.state.thirdValueVersion.length > 0) &&
            (this.state.fourthValueVersion && this.state.fourthValueVersion.length > 0)
        )
        ) {
            isOK = false;
            errors.message = errors.message + 'please enter version information.,';
        }

        //Grouping Criteria
        if (!(this.state.criteriaSelected && this.state.criteriaSelected.name !== 'select a criteria')) {
            isOK = false;
            errors.message = errors.message + 'please select a criteria.,';
        }


        if (this.state.groupByCommunity && (!this.state.communitiesSelected || (this.state.communitiesSelected && this.state.communitiesSelected.length === 0))) {
            isOK = false;
            errors.message = errors.message + 'please select at least one community.';

        } else if (!this.state.groupByCommunity && (!this.state.residentsSelected || (this.state.residentsSelected && this.state.residentsSelected.length === 0))) {
            isOK = false;
            errors.message = errors.message + 'please select at least one resident.';
        }

        return isOK;
    };

    toggleSwitchGroupByCommunity = () => {

        //Clean ResidentsReducer 
        this.props.GetResidentsByTags('');

        this.props.GetCommunitiesByTags('');

        this.setState((prevState) => ({ groupByCommunity: !prevState.groupByCommunity, criteriaSelected: undefined, residentsSelected: [], communitiesSelected: [] }))
    }
    //#endregion

    //#region  Inner Components Version Information
    RenderVersionInformationComponent = () => {
        const styles = {
            container: {
                height: this.state.fixedHeight,
                backgroundColor: this.state.fixedBackgroundColor,
                color: 'white',
                borderRadius: this.state.fixedBorderRadius,
            },
            title: {
                color: '#a5a3a4',
                fontSize: '1rem'
            }
        }

        const flavor = this.state.flavorSelected ? this.state.flavorSelected.name : 'staging';
        const version = (this.state.firstValueVersion && this.state.secondValueVersion && this.state.thirdValueVersion && this.state.fourthValueVersion) ?
            `${this.state.firstValueVersion}.${this.state.secondValueVersion}.${this.state.thirdValueVersion}.${this.state.fourthValueVersion}` : '';

        return (
            <Grid item container xs={12} lg={11} justify='center' alignItems='center'>
                <Grid item container xs={12} style={{ ...styles.title }}>Version Information</Grid>
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.container }}>
                    <Grid item container xs={10} >
                        <Grid item container xs={6} style={{ padding: '10px' }}>
                            <this.RenderFlavorComboComponent />
                        </Grid>
                        <Grid item container xs={6} style={{ padding: '10px' }}>
                            <this.RenderVersionComponent />
                        </Grid>
                        {
                            this.props.versionSelected ?
                                <Grid item container xs={12} style={{ padding: '10px' }}>
                                    <this.AprovedComponent />
                                </Grid>
                                :
                                undefined
                        }
                        <Grid item container xs={12} style={{ padding: '10px' }}>
                            <this.DesciptionComponent />
                        </Grid>
                        <Grid item container xs={12} style={{ padding: '10px' }}>
                            <this.RenderUrlComponent
                                flavor={flavor}
                                version={version}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        );
    };

    RenderFlavorComboComponent = () => {

        const onError = (!this.state.flavorSelected || (this.state.flavorSelected?.name?.length === 0));

        return (
            <Grid item container xs={12}>
                <Grid item container >Flavor</Grid>
                <Field
                    showStartAdornment={true}
                    name="AddVersionFlavor"
                    maxLength={20}
                    selected={this.state.flavorSelected ? this.state.flavorSelected : { name: '' }}
                    optionsItemsIconsData={this.state.flavors ? this.state.flavors : []}
                    onChangeHandler={(e, newItem) => {
                        this.setState({ flavorSelected: newItem });
                        this.props.dispatch(change('AddVersionForm', 'AddVersionFlavor', newItem));
                        this.handleVersionFlavorCombo(null, false);

                    }
                    }
                    component={renderSelect}
                    open={this.state.openVersionFlavorCombo}
                    onClick={this.handleVersionFlavorCombo}
                    onBlur={this.handleVersionFlavorOnBlur}
                    helperText={(onError) ? 'required' : undefined}
                    error={onError}
                    autoCompleteStyles={{ paddingRight: '0px' }}
                    idToSet="Version_flavor_dropdown"
                />
            </Grid>
        );
    };

    RenderVersionComponent = () => {
        const positions = ['firstValueVersion', 'secondValueVersion', 'thirdValueVersion', 'fourthValueVersion']
        const styles = {
            numberGrid: {
                borderRadius: '12px',
                height: '2rem',
                paddingRight: '3px'
            }
        };

        return (
            <Grid item container xs={12}>
                <Grid item container >Latest Version</Grid>
                <Grid item container xs={12} justify='space-between' alignItems='center'>
                    {
                        (positions && positions.length > 0) ?
                            positions.map(
                                (position, index) => {
                                    let value = '';
                                    let onError = false;
                                    let onFocus = position + 'Focused';


                                    if (position === 'firstValueVersion') {
                                        value = this.state.firstValueVersion ? this.state.firstValueVersion : '';
                                        onError = (!!!this.state.firstValueVersion && this.state.firstValueVersionFocused);

                                    } else if (position === 'secondValueVersion') {
                                        value = this.state.secondValueVersion ? this.state.secondValueVersion : '';
                                        onError = (!!!this.state.secondValueVersion && this.state.secondValueVersionFocused);

                                    } else if (position === 'thirdValueVersion') {
                                        value = this.state.thirdValueVersion ? this.state.thirdValueVersion : '';
                                        onError = (!!!this.state.thirdValueVersion && this.state.thirdValueVersionFocused);

                                    } else if (position === 'fourthValueVersion') {
                                        value = this.state.fourthValueVersion ? this.state.fourthValueVersion : '';
                                        onError = (!!!this.state.fourthValueVersion && this.state.fourthValueVersionFocused);

                                    }


                                    return (
                                        <Grid item container xs={3} key={'portionVersion' + index}>
                                            <TextField
                                                id={`latest_version_${index}`}
                                                style={{ ...styles.numberGrid }}
                                                placeholder='000'
                                                inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                                onChange={(e) => this.checkValidInput(e.target.value, position)}
                                                value={value}
                                                helperText={(onError) ? 'required' : undefined}
                                                error={onError}
                                                onBlur={() => this.setState({ [onFocus]: true })}
                                            />
                                        </Grid>
                                    )
                                }
                            )
                            :
                            <Grid></Grid>
                    }
                </Grid>
            </Grid>
        );
    };

    RenderUrlComponent = ({ flavor = '', version = '' }) => {
        return (
            <Grid item container xs={12}>
                <Grid item container xs={12}> Url </Grid>
                <Grid item container xs={12}>
                    <TextField
                        id='version_url_field'
                        style={{ width: '100%' }}
                        defaultValue={`https://engage360.s3.amazonaws.com/app/${flavor}/engage360-${flavor}-${version}.apk`}
                        onChange={(e) => { this.setState({ versionUrl: e.target.value }) }}
                    />
                </Grid>
            </Grid>
        );
    };

    AprovedComponent = () => {
        const checked = this.state.versionAproved;
        const classForCheckBox = checked ? 'isChecked' : '';

        try {
            return (
                <Grid item container xs={12}>
                    <Grid item container xs={10} alignContent='center' justify='flex-end'>
                        <Grid>Approved</Grid>
                    </Grid>
                    <Grid item container xs={2}>
                        <Checkbox
                            id='version_checkbox_approved'
                            checked={checked}
                            onChange={() => this.setState((prevState) => ({ versionAproved: !prevState.versionAproved }))}
                            name={'checkBoxAprovedVersion'}
                            className={classForCheckBox}

                        />
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (
                <Grid></Grid>
            )
        }
    };

    DesciptionComponent = () => {
        try {
            return (
                <Grid item container xs={12}>
                    <Grid item container xs={12}> Description </Grid>
                    <Grid item container xs={12}>
                        <TextField
                            style={{ width: '100%' }}
                            value={this.state.versionDescription}
                            onChange={(e) => { this.setState({ versionDescription: e.target.value }) }}
                            id='version_description_field'
                        />
                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (
                <Grid></Grid>
            )
        }
    };
    //#endregion

    //#region Inner Componnet Grouping Component
    RenderGroupingInformationComponent = () => {

        const styles = {
            container: {
                height: '12rem',
                backgroundColor: this.state.fixedBackgroundColor,
                color: 'white',
                borderRadius: this.state.fixedBorderRadius,
            },
            title: {
                color: '#a5a3a4',
                fontSize: '1rem'
            }
        }

        return (
            <Grid item container xs={12} lg={11} justify='center' alignItems='center'>
                <Grid item container xs={12} style={{ ...styles.title }}>Grouping Information</Grid>
                <Grid item container xs={12} justify='center' alignContent='center' style={{ ...styles.container }}>
                    <Grid item xs={10} sm={10} md={9} lg={6}>
                        <this.RenderGroupByCommunitySwitchComponent />
                        <this.RenderGroupCriteriaComponent />
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderGroupByCommunitySwitchComponent = () => {

        const size = (this.state.rootFontSize && this.state.rootFontSize.name) ? this.state.rootFontSize.name : 'md'
        const fontSize = (size === 'xs') ? '12px' : (size === 'sm') ? '14px' : size === 'md' ? '15px' : '18px'



        const styles = {
            labelStyles: {
                fontSize: fontSize,
            }
        }
        return (
            <Field
                label={'Group by Community'}
                name='GroupBayCommunitySwitch'
                checked={this.state.groupByCommunity ? this.state.groupByCommunity : false}
                onClick={() => this.toggleSwitchGroupByCommunity()}
                component={renderSwitchWithLabel}
                stylesLabel={styles.labelStyles}
                idToSet="version_group_by_community_switch"
            />

        );
    };


    RenderGroupCriteriaComponent = () => {
        const byCommunity = [{ id: 0, name: 'Select a criteria' }, { id: 1, name: 'by community tag' }, { id: 2, name: 'by Community' }];
        const byResident = [{ id: 0, name: 'Select a criteria' }, { id: 1, name: 'by resident tag' }, { id: 2, name: 'by resident' }, { id: 3, name: 'by resident by community' }];

        const criteriaOptions = this.state.groupByCommunity ? byCommunity : byResident;
        let optionSelected = undefined;

        let onError = false;


        if (criteriaOptions) {
            if (this.state.criteriaSelected) {

                optionSelected = criteriaOptions.find(criteria => criteria.name === this.state.criteriaSelected.name);

                if (!optionSelected) {
                    optionSelected = criteriaOptions[0];
                }
            } else {
                optionSelected = criteriaOptions[0];
            }
        } else {
            optionSelected = {};
        };

        if (optionSelected && optionSelected.name === 'Select a criteria' && this.state.criteriaFocused && this.state.criteriaFocused === true) {
            onError = true;
        }

        return (
            <Grid item container xs={12}>
                <Grid item container >Criteria</Grid>
                <Field
                    id='version_criteria_component'
                    showStartAdornment={true}
                    name="GroupingCriteria"
                    maxLength={20}
                    selected={optionSelected ? optionSelected : { name: '' }}
                    optionsItemsIconsData={criteriaOptions}
                    onChangeHandler={
                        (e, newItem) => {
                            this.SetCriteriaSelected(newItem);
                            this.props.dispatch(change('AddVersionForm', 'GroupingCriteria', newItem));
                            this.handleGroupCriteriaCombo(null, false);
                        }
                    }
                    helperText={onError ? 'select an option' : undefined}
                    // onBlur={() => this.setState({'criteriaFocused':true})}
                    error={onError}
                    component={renderSelect}
                    open={this.state.openGroupCriteriaCombo}
                    onClick={this.handleGroupCriteriaCombo}
                    onBlur={this.handleGroupCriteriaOnBlur}
                    autoCompleteStyles={{ paddingRight: '0px' }}
                    idToSet="version_criteria_dropdown"
                />
            </Grid>
        );
    };


    //#endregion

    //#region Inner Componet Tags Component
    RenderTagsComponent = () => {
        const size = (this.state.rootFontSize && this.state.rootFontSize.name) ? this.state.rootFontSize.name : 'md'
        const fontSize = (size === 'xs' || size === 'sm') ? '15px' : size === 'md' ? '16px' : '18px'

        const styles = {
            container: {
                height: '30rem',
                overflow: 'auto',
                backgroundColor: '#1f1f1f',
                color: 'white',
                borderRadius: '12px'
            },
            title: {
                color: '#a5a3a4',
                fontSize: '1rem'
            },
            labelStyles: {
                fontSize: fontSize,
            },
        }

        const tags = this.state.criteriaSelected.name === 'by community tag' ? this.props.communityTags : this.props.residentTags;
        return (
            <Grid item container xs={12} justify='center' alignItems='center'>
                <Grid item container xs={12} style={{ ...styles.title }}>Tags</Grid>
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.container }}>
                    <Grid item container xs={12} justify='flex-start' alignItems='center' style={{ height: '10%' }}>
                        <Grid item xs={12} md={6} lg={4} style={{ padding: '0px 5px', margin: '0px 15px', }} >
                            <Field
                                label={'Select All '}
                                checked={this.state.selectAllTags ? this.state.selectAllTags : false}
                                onClick={() => this.SelectAllTags()}
                                component={renderSwitchWithLabel}
                                labelInLeft={true}
                                stylesLabel={styles.labelStyles}
                                idToSet="version_select_all_tags_switch"
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={10} justify='center' alignItems='flex-start' style={{ height: '90%' }}>
                        {
                            tags ?
                                tags.map(
                                    (tag, index) => this.RenderTagComponent(tag, index)
                                )
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderTagComponent = (tag, index) => {

        const criteriaSelected = (this.state.criteriaSelected && this.state.criteriaSelected.name) ? this.state.criteriaSelected.name : '';
        const arrayCheckedTags = criteriaSelected === 'by community tag' ? this.state.arrayCheckedTagsCommunity : this.state.arrayCheckedTagsResident;
        const checked = arrayCheckedTags.indexOf(tag) !== -1 ? true : false;
        const classForCheckBox = checked ? 'isChecked' : '';

        return (
            <Grid item container xs={12} key={'tag' + index} style={{ overflow: 'hidden' }} justify='center' alignItems='center' id={`version_tags_item_${index}`}>
                <Grid item xs={3} style={{ textAlign: 'right' }}>
                    <Checkbox
                        id={`version_tags_checkbox_${index}`}
                        checked={checked}
                        onChange={() => this.AddTagToCheckedArray(tag, criteriaSelected)}
                        name={'checkBox' + index}
                        className={classForCheckBox}

                    />
                </Grid>
                <Grid item xs={9} style={{ textAlign: 'left' }}>{tag}</Grid>
            </Grid>
        );
    };
    //#endregion

    //#region Inner Componnet Residents Component
    RenderResidentsData = ({ ResidentsData }) => {

        const size = (this.state.rootFontSize && this.state.rootFontSize.name) ? this.state.rootFontSize.name : 'md'
        const fontSize = (size === 'xs' || size === 'sm') ? '15px' : size === 'md' ? '16px' : '18px'

        const styles = {
            container: {
                height: '30rem',
                overflow: 'auto',
                backgroundColor: '#1f1f1f',
                color: 'white',
                borderRadius: '12px'
            },
            title: {
                color: '#a5a3a4',
                fontSize: '1rem'
            },
            labelStyles: {
                fontSize: fontSize,
            },
        }



        return (

            <Grid item container xs={12} justify='center' alignItems='flex-start'>
                <Grid item container xs={12} alignItems='flex-start' style={{ ...styles.title }}>
                    <Grid item xs={12} alignItems='flex-start' style={{ textAlign: 'left' }}>
                        residents
                    </Grid>
                </Grid>
                <Grid item container xs={12} justify='center' alignItems='flex-start' style={{ ...styles.container }}>
                    <Grid item container xs={12} justify='flex-start' alignItems='center' style={{ height: '10%' }}>
                        <Grid item xs={12} md={6} lg={4} style={{ padding: '0px 5px', margin: '0px 15px', }} >
                            <Field
                                label={'Select All '}
                                checked={this.state.selectAllResidents ? this.state.selectAllResidents : false}
                                onClick={() => this.SelectAllResidents(ResidentsData)}
                                component={renderSwitchWithLabel}
                                labelInLeft={true}
                                stylesLabel={styles.labelStyles}
                                idToSet='version_select_all_residents_switch'
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={10} justify='center' alignItems='flex-start' style={{ height: '90%' }}>
                        {
                            (ResidentsData && ResidentsData.length > 0) ?
                                ResidentsData.map(
                                    (resident, index) => this.RenderResidentComponent(resident, index)
                                )
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderResidentComponent = (resident, index) => {

        const styles = {
            container: {
                overflow: 'hidden',
                margin: '10px 0px',
            },
            img: {
                height: '100px',
                width: '100px',
                borderRadius: '50%',
                backgroundColor: 'green',
                textAlign: 'center',
                verticalAlign: 'middle'
            },
            residentName: {
                height: '30px',
                display: 'inline',
                textAlign: 'center',
                overflow: 'hidden',
            },
            residentContainer: {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                backgroundColor: '#92949c',
                padding: '10px 0',
            },
            checkBoxContainer: {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
                backgroundColor: '#454446',
            },
        }

        const residentPicture = resident.pictureUrl ? resident.pictureUrl : 'https://engage360.s3.amazonaws.com/Residents/profile.png';
        let residentName = (resident.firstName ? resident.firstName : '') + ' ' + (resident.lastName ? resident.lastName : '');
        let zoneName = resident.zoneName ? resident.zoneName : '';
        const checked = this.state.residentsSelected ? !!this.state.residentsSelected.find(res => res._id === resident._id) : false;
        const classForCheckBox = checked ? 'isChecked' : '';

        if (this.props.residentsData && !this.state.residentsSelected && this.props.versionSelected && this.props.versionSelected.residents) {
            const newResident = this.GetResidentsSelected(this.props.versionSelected.residents, this.props.residentsData);

            this.setState({ residentsSelected: newResident });
        }

        if (residentName.length > 25) {
            residentName = residentName.slice(0, 23) + '...';
        }

        if (zoneName.length > 15) {
            zoneName = zoneName.slice(0, 13) + '...';
        }
        const nameToShow = residentName + ', ' + zoneName;

        return (
            <Grid item container xs={12} justify='center' alignItems='center' key={'residentcomponent' + index} style={{ ...styles.container }} id={`version_resident_${index}`}>
                <Grid item container xs={11} justify='center' alignItems='center' style={{ ...styles.residentContainer }}>
                    <Grid item container xs={12} justify='center' alignItems='center' >
                        {
                            residentPicture ?
                                <img
                                    style={{ ...styles.img }}
                                    src={residentPicture}
                                    alt={'resident ' + residentName}
                                >
                                </img>
                                :
                                <Grid item container style={{ ...styles.img }} justify='center' alignItems='center'>
                                    <Grid item >
                                        {this.GetResidentBadge(residentName)}
                                    </Grid>
                                </Grid>
                        }
                    </Grid>

                </Grid>
                <Grid item container xs={11} justify='center' alignItems='center' style={{ ...styles.checkBoxContainer }}>
                    <Grid item xs={5} style={{ textAlign: 'right' }}>
                        <Checkbox
                            checked={checked}
                            onChange={() => this.AddResidentToSelectedArray(resident)}
                            name={'checkBox' + index}
                            className={classForCheckBox}
                            id={`version_resident_checkbox_${index}`}
                        />
                    </Grid>
                    <Grid item xs={7} style={{ textAlign: 'left' }}>{nameToShow}</Grid>
                </Grid>
            </Grid>)
    }
    //#endregion

    //#region Inner Component Communities Componnet
    RenderCommunitiesComponent = () => {

        const size = (this.state.rootFontSize && this.state.rootFontSize.name) ? this.state.rootFontSize.name : 'md'
        const fontSize = (size === 'xs' || size === 'sm') ? '15px' : size === 'md' ? '16px' : '18px'

        const communitiesData = (this.props.communityData && this.props.communityData.length > 0) ? this.props.communityData : [];

        const styles = {
            container: {
                height: '30rem',
                overflow: 'auto',
                backgroundColor: '#1f1f1f',
                color: 'white',
                borderRadius: '12px'
            },
            title: {
                color: '#a5a3a4',
                fontSize: '1rem'
            },
            labelStyles: {
                fontSize: fontSize,
            },
        }

        return (
            <Grid item container xs={12} justify='center' alignItems='center'>
                <Grid item container xs={12} style={{ ...styles.title }}>
                    <Grid item container xs={8}>
                        Communities
                    </Grid>

                </Grid>
                <Grid item container xs={12} justify='center' alignItems='center' style={{ ...styles.container }}>
                    <Grid item container xs={12} justify='flex-start' alignItems='center' style={{ height: '10%' }}>
                        <Grid item xs={12} md={6} lg={4} style={{ padding: '0px 5px', margin: '0px 15px' }} >
                            <Field
                                label={'Select All '}
                                name='SelectAllCommunitiesSwitch'
                                checked={this.state.selectAllCommunities ? this.state.selectAllCommunities : false}
                                onClick={() => this.SelectAllCommunities()}
                                component={renderSwitchWithLabel}
                                labelInLeft={true}
                                stylesLabel={styles.labelStyles}
                                idToSet='version_select_all_communities_switch'
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={10} justify='center' alignItems='flex-start' style={{ height: '90%' }}>
                        {
                            (communitiesData) ?
                                communitiesData.map(
                                    (community, index) => this.RenderCommunityComponent(community, index)
                                )
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderCommunityComponent = (community, index) => {
        const styles = {
            container: {
                overflow: 'hidden',
                margin: '10px 0px'
            },
            img: {
                height: '100px',
                width: '100px',
                borderRadius: '50%',
                backgroundColor: 'green',
                textAlign: 'center',
                verticalAlign: 'middle'
            },
            communityName: {
                height: '30px',
                display: 'inline',
                textAlign: 'left',
                overflow: 'hidden',
            },
            CommunityContainer: {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                backgroundColor: '#92949c',
            },
            communityContainer: {
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                backgroundColor: '#92949c',
                padding: '10px 0',
            },
            checkBoxContainer: {
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
                backgroundColor: '#454446',
            },
        }

        const communityName = (community.name ? community.name : '');
        const checked = this.state.communitiesSelected ? this.state.communitiesSelected.find(comm => comm._id === community._id) !== undefined ? true : false : false;
        const classForCheckBox = checked ? 'isChecked' : '';

        if (this.props.communityData && !this.state.communitiesSelected && this.props.versionSelected && this.props.versionSelected.communities) {

            const newCommunities = this.GetCommunitiesSelected(this.props.versionSelected.communities, this.props.communityData);

            this.setState({ communitiesSelected: newCommunities });
        }

        return (
            <Grid item container xs={12} justify='center' alignItems='center' key={'residentcomponent' + index} style={{ ...styles.container }} id={`version_community_${index}`}>
                <Grid item container xs={11} justify='center' alignItems='center' style={{ ...styles.communityContainer }}>
                    <Grid item container xs={12} justify='center' alignItems='center' >
                        {
                            <Grid item container style={{ ...styles.img }} justify='center' alignItems='center'>
                                <Grid item >
                                    {this.GetResidentBadge(communityName)}
                                </Grid>
                            </Grid>
                        }
                    </Grid>

                </Grid>
                <Grid item container xs={11} justify='center' alignItems='center' style={{ ...styles.checkBoxContainer }}>
                    <Grid item container xs={5} justify='flex-end' alignItems='center' style={{ textAlign: 'right' }}>
                        <Checkbox
                            checked={checked}
                            onChange={() => this.toggleCommunitySelected(community)}
                            name={'checkBox' + index}
                            className={classForCheckBox}
                            id={`version_resident_checkbox_${index}`}
                        />
                    </Grid>
                    <Grid item container xs={7} justify='flex-start' alignItems='center' style={{ ...styles.communityName }}>{communityName}</Grid>
                </Grid>
            </Grid>
        );

    };
    //#endregion Inner Component Communities Componnet

    //#region  Handlers
    GetCommunitiesSelected = (communities = undefined, communitiesData = undefined) => {
        try {
            const communitiesSelectedArray = [];

            if (!communities || communities.length === 0 || !communitiesData || communitiesData.length === 0)
                return [];

            for (let i = 0; i < communities.length; i++) {

                const communityObj = communities[i];
                for (let j = 0; j < communitiesData.length; j++) {
                    const communityDataObj = communitiesData[j];

                    if (communityObj === communityDataObj.communityId) {
                        communitiesSelectedArray.push(communityDataObj);
                    }
                }
            }

            return communitiesSelectedArray;
        } catch (err) { }
    }

    GetResidentsSelected = (residents = undefined, residentsData = undefined) => {
        try {
            const residentsSelectedArray = [];

            if (!residents || residents.length === 0 || !residentsData || residentsData.length === 0)
                return [];

            for (let i = 0; i < residents.length; i++) {

                const residentObj = residents[i];
                for (let j = 0; j < residentsData.length; j++) {
                    const residentDataObj = residentsData[j];


                    if (residentObj === residentDataObj._id) {
                        residentsSelectedArray.push(residentDataObj);
                    }
                }
            }

            return residentsSelectedArray;
        } catch (err) { }
    }


    handleVersionFlavorCombo = (e, option) => {

        if (!option) {
            this.setState((prevState) => ({ openVersionFlavorCombo: !prevState.openVersionFlavorCombo }));
        } else {
            this.setState({ openVersionFlavorCombo: option });
        }
    }
    handleVersionFlavorOnBlur = () => {
        setTimeout(() => {
            this.setState({ openVersionFlavorCombo: false })
        }, 50);
    }

    handleGroupCriteriaCombo = (e, option) => {

        if (!option) {
            this.setState((prevState) => ({ openGroupCriteriaCombo: !prevState.openGroupCriteriaCombo }));
        } else {
            this.setState({ openGroupCriteriaCombo: option });
        }
    }
    handleGroupCriteriaOnBlur = () => {
        setTimeout(() => {
            this.setState({ openGroupCriteriaCombo: false })
        }, 50);
    }
    //#endregion

    initialswitch = undefined;
    render() {

        //#region  Initial state siwtches
        if (!this.initialswitch &&
            (
                (this.props.communitiesData && this.props.communitiesData.length > 0) ||
                (this.props.residentsData && this.props.residentsData.length > 0)
            ) &&
            this.props.versionSelected
        ) {
            this.initialswitch = true;

            const communities = (this.props.versionSelected && this.props.versionSelected.communities && this.props.versionSelected.communities.length > 0) ? this.props.versionSelected.communities : undefined;
            const initialStateCommunitiesSwitch = (this.props.communityData && this.props.communityData.length > 0 && communities) ? this.props.communityData.length === communities.length : false;

            const residents = (this.props.versionSelected && this.props.versionSelected.residents && this.props.versionSelected.residents.length > 0) ? this.props.versionSelected.residents : undefined;
            const initialStateResidentsSwitch = (this.props.residentsData && this.props.residentsData.length > 0 && residents) ? this.props.residentsData.length === residents.length : false;

            this.setState({ selectAllCommunities: initialStateCommunitiesSwitch, selectAllResidents: initialStateResidentsSwitch });
        }
        //#endregion

        const criteriaSelected = (this.state.criteriaSelected && this.state.criteriaSelected.name) ? this.state.criteriaSelected : undefined;
        let ResidentsData = this.props.residentsData ? [...this.props.residentsData] : [];
        const communitiesSelected = this.state.communitiesSelected ? this.state.communitiesSelected : [];

        const communitiesId = communitiesSelected.map(comm => comm._id);


        if ((criteriaSelected && criteriaSelected.name)) {
            switch (criteriaSelected.name) {

                case 'by resident tag':
                    break;
                case 'by resident':
                    break;
                case 'by resident by community':
                    ResidentsData = ResidentsData.filter(
                        res => {
                            if (communitiesId.indexOf(res.communityId) !== -1) {
                                return true
                            } else {
                                return false
                            }

                        }
                    );
                    break;
                case 'by community tag':
                    break;
                case 'by Community':
                    break;
                default:
                    break;
            }
        }


        return (
            <React.Fragment>
                <AppBar position="static" className="dark">
                    <Toolbar>
                        <Typography variant="h6">
                            <div id='version_Chevronlist_AddEditVersion' className="engage-nav ToolbalCommunityName" onClick={this.props.closeAddEditPage}>
                                <img
                                    src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                    alt='return'
                                    className="returnIcon"
                                />
                                EHub Version
                            </div>
                        </Typography>


                        {/* <Typography variant="h6" >
                            EHub Version
                        </Typography>
                        */}
                    </Toolbar>
                </AppBar>
                <main style={{ flexGrow: '1', padding: '7px 20px', zIndex: '1300' }}>
                    <div className="activityTitle-engage">
                        <Grid container justify='center' alignItems='center'>
                            <Grid item container xs={12} sm={12} md={12} lg={11} justify='space-between' alignItems='flex-start'>

                                <Grid item container xs={12} sm={12} md={12} lg={6} justify='flex-start' alignItems='center' style={{ paddingTop: '20px' }}>
                                    <this.RenderVersionInformationComponent />
                                </Grid>

                                <Grid item container xs={12} sm={12} md={12} lg={6} justify='flex-end' alignItems='center' style={{ paddingTop: '20px' }}>
                                    <this.RenderGroupingInformationComponent />
                                </Grid>

                                {
                                    this.state.criteriaSelected &&
                                        (this.state.criteriaSelected.name === 'by community tag' || this.state.criteriaSelected.name === 'by resident tag') ?
                                        <Grid item container xs={12} sm={12} md={12} lg={6} justify='flex-start' alignItems='center' style={{ paddingTop: '20px' }}>
                                            <Grid item container xs={12} sm={12} md={12} lg={11} justify='flex-start' alignItems='center'>
                                                <this.RenderTagsComponent />
                                            </Grid>
                                        </Grid>
                                        :
                                        undefined
                                }

                                {
                                    this.state.criteriaSelected && (this.props.communityData && this.props.communityData.length > 0) &&
                                        (this.state.criteriaSelected.name === 'by resident by community' || this.state.criteriaSelected.name === 'by Community' || this.state.criteriaSelected.name === 'by community tag') ?
                                        <Grid item container xs={12} sm={12} md={12} lg={6} justify={(this.state.criteriaSelected && this.state.criteriaSelected.name === 'by community tag') ? 'flex-end' : 'flex-start'} alignItems='center' style={{ paddingTop: '20px' }}>
                                            <Grid item container xs={12} sm={12} md={12} lg={11} justify={(this.criteriaSelected && this.criteriaSelected.name === 'by community tag') ? 'flex-end' : 'flex-start'} alignItems='center'>
                                                <this.RenderCommunitiesComponent />
                                            </Grid>
                                        </Grid>
                                        :
                                        undefined
                                }
                                {
                                    (!this.state.groupByCommunity) &&
                                        (ResidentsData && ResidentsData.length > 0) ?
                                        <Grid item container xs={12} sm={12} md={12} lg={6} justify={(this.state.criteriaSelected && this.state.criteriaSelected.name === 'by resident') ? 'flex-start' : 'flex-end'} alignItems='center' style={{ paddingTop: '20px' }}>
                                            <Grid item container xs={12} sm={12} md={12} lg={11} justify={(this.state.criteriaSelected && this.state.criteriaSelected.name === 'by resident') ? 'flex-start' : 'flex-end'} alignItems='center'>
                                                <this.RenderResidentsData ResidentsData={ResidentsData} />
                                            </Grid>
                                        </Grid>
                                        :
                                        undefined
                                }
                            </Grid>
                        </Grid>
                    </div>
                </main>
            </React.Fragment>
        );
    }
}


function mapStateToProps(state) {
    const residentTags = (state.residentReducer && state.residentReducer.tags && state.residentReducer.tags.tags) ? state.residentReducer.tags.tags : undefined;
    const communityTags = (state.communityReducer && state.communityReducer.tags && state.communityReducer.tags.tags) ? state.communityReducer.tags.tags : undefined;
    const residentsData = (state.residentReducer && state.residentReducer.residentDataSTBVersion) ? state.residentReducer.residentDataSTBVersion : undefined;
    const communityData = (state.communityReducer && state.communityReducer.communityDataSTBVersion) ? state.communityReducer.communityDataSTBVersion.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId })) : [];

    return {
        residentTags: residentTags,
        communityTags: communityTags,
        residentsData: residentsData,
        communityData: communityData,
    }

};


export default connect(mapStateToProps, { GetResidetTags, GetResidentsByTags, GetResidentsAllCommunities, GetCommunityTags, getAllCommunitiesSTBVerison, GetCommunitiesByTags, PostVersion, SetHeaderButtons, PutVersion, GetAllVersions })(reduxForm({
    form: 'AddVersionForm',
    validate,
    enableReinitialize: true,
})(AddVersion));